import styled from 'styled-components';

export const JackpotAmountDefaultBox = styled.div`
    color:  ${props => props.theme.colors.brandSecondary};
    font-family: ${props => props.theme.font.family.ultra};
    font-size: 2.6em;
    width: 100%;
    margin-bottom: 4px;
    @media ${({theme}) => theme.mediaQuery.xlExact} {
        font-size: 2.2em;
    }
`;
